export default "__VITE_ASSET__DISCjkL7__"